import mapFunction from './mapResources';

export default mapFunction('default_entity_operations', {
    isFetching: false,
    items: []
});